import React from 'react';
import './style/TodoNewTask.css';

function TodoNewTask() {
    return (
        <h2 className='h2_NewTasks'>Create new TodoTask</h2>
    );
}

export { TodoNewTask};